export const PLANNING_AUTHORITY_LAYER_TYPE_ID = "PLANNING_AUTHORITY_LAYER_TYPE_ID";
export const PLANNING_AUTHORITY_LAYER_APPROVAL_RATE_SUMMARY_TYPE_ID =
  "PLANNING_AUTHORITY_LAYER_APPROVAL_RATE_SUMMARY_TYPE_ID";
export const PLANNING_AUTHORITY_LAYER_PIF_SUMMARY_TYPE_ID = "PLANNING_AUTHORITY_LAYER_PIF_SUMMARY_TYPE_ID";
